import script from "./LuceMark.vue?vue&type=script&setup=true&lang=js"
export * from "./LuceMark.vue?vue&type=script&setup=true&lang=js"

import "./LuceMark.vue?vue&type=style&index=0&id=1554b2f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1554b2f6"]])

export default __exports__